import { Box, MenuItem, Pagination, Select } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import Typography from '@mui/material/Typography';

import { CANVASSING_SESSION_ROWS_PER_PAGE_OPTIONS } from './useCanvassingSessionList';

export type CanvassingSessionTableFooterProps = {
  total: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

export const CanvassingSessionTableFooter = ({
  total,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: CanvassingSessionTableFooterProps) => {
  const pageCount = Math.max(1, Math.ceil(total / rowsPerPage));

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
        minHeight: 52,
        px: 2,
        py: 0.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Rows per page:
        </Typography>
        <Select
          variant="standard"
          disableUnderline
          size="small"
          value={rowsPerPage}
          onChange={(event: SelectChangeEvent<number>) => onRowsPerPageChange(Number(event.target.value))}
          inputProps={{ 'aria-label': 'Rows per page' }}
        >
          {CANVASSING_SESSION_ROWS_PER_PAGE_OPTIONS.map(option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Pagination
        count={pageCount}
        page={page + 1}
        onChange={(_event, nextPage) => onPageChange(nextPage - 1)}
        showFirstButton
        showLastButton
        shape="rounded"
        size="small"
      />
    </Box>
  );
};
